import React from "react";
import { injectIntl } from "@irati/utils/lang";
import { ErrorCard } from "./styled/LoadingServerError";
var LoadingServerError = function (props) {
    var _a;
    var errorMsg = props.errorMsg, formatMessage = props.formatMessage;
    var errorMessage = ((_a = errorMsg) === null || _a === void 0 ? void 0 : _a.error) || formatMessage({ id: "platform.loadingServerError.default.error" });
    return React.createElement(ErrorCard, null, errorMessage);
};
export default injectIntl(LoadingServerError);
